function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhysicalRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uADF8\\uB8F9 137212",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "itv91hprta"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 117115",
    style: {
      fill: "#d7262e"
    },
    d: "M0 0h40.992v41.021H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137199"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137198",
    transform: "translate(7.504 7.511)",
    style: {
      clipPath: "url(#itv91hprta)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121129",
    d: "M6.834 13.705a6.829 6.829 0 1 1 6.829-6.829 6.829 6.829 0 0 1-6.829 6.829m6.716.887 17.585 17.586a18.506 18.506 0 0 0 4.51-3.319 17.925 17.925 0 0 0 5.334-12.153 16.065 16.065 0 0 0-4.67-11.982 16.636 16.636 0 0 0-20.256-2.3 10.176 10.176 0 0 1-2.5 12.171m-3.01 1.82a10.22 10.22 0 0 1-3.66.707 18.123 18.123 0 0 0 1.8 8.536.825.825 0 0 1-.138.987l-6.348 4.4A5.742 5.742 0 0 0 0 35.158a4.82 4.82 0 0 0 1.461 3.672l.759.721a5.029 5.029 0 0 0 3.557 1.47 5.463 5.463 0 0 0 3.884-1.843l4.684-6.693a.853.853 0 0 1 1.024-.2 17.827 17.827 0 0 0 12.292 1.259z",
    style: {
      fill: "#d7262e"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhysicalRed);
export default __webpack_public_path__ + "static/media/icon_physical_red.22055091c49da4855b99b6a4aa6e4e39.svg";
export { ForwardRef as ReactComponent };